import React from 'react';
import coverbackground from '../../assets/vote01.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollVote extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        
        description="Vote"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollVote;